import type { paths } from "./schema";

/**
 * 指定されたAPI pathのキーに対応する文字列を取得する
 *
 * @example
 * const path = getPath("/v2/sample/hello");
 * console.log(path); // "/v2/sample/hello"
 */
export function getPath<Path extends keyof paths>(path: Path): Path {
  return path;
}
